import { useGetListRoleQuery, useGetSedeQuery } from "../store/services/LookUpService"


export default function RuoliLookUp() {
    const {data} = useGetListRoleQuery('');
    let optionRuoli = data?.map((sede: string) => ({value: sede, label: sede}))
    return optionRuoli;
}